// extracted by mini-css-extract-plugin
export default {"Image":"ImageWithCaption_Image__e7zID","Container":"ImageWithCaption_Container__Q+UQw"};